<div>
    <nz-tabs>
        <nz-tab *ngFor="let tab of tabs" [nzTitle]="titleTemplate" [nzDisabled]="tab.disabled">
            <ng-template #titleTemplate>

            <nz-icon [nzType]="tab.icon" [nzTheme]="tab.themeIcon!=null?tab.themeIcon:'outline'"
                [nzTwotoneColor]="tab.twotoneColor!=null?tab.twotoneColor:''" >
            </nz-icon>
                {{ tab.name |translateTA }}
             </ng-template>
        
            <nz-collapse>
                <nz-collapse-panel *ngFor="let item of layoutMapPanel[tab.id] | keyvalue"
                    [nzHeader]="item.value[0].name |translateTA" [nzActive]="item.value[0].active" [nzDisabled]="item.value[0].disabled">
                    @let panel = item.value[0];
                    @let formDetail = this.form;
                    <form nz-form [formGroup]="formDetail" [nzLayout]="'vertical'">
                        <div nz-row *ngFor="let row of layoutMap[panel.id] | keyvalue" [nzGutter]="16">
                            <nz-col *ngFor="let field of row.value" [nzSpan]="field.colSpan" [nzOrder]="field.col">
                                <webhook-common [mainformGroup]="formDetail" [field]="field" [variables]="variables"  [configuration]="this.configuration"  [rootForm]="formDetail"> </webhook-common>
                            </nz-col>
                        </div>
                    </form>
                </nz-collapse-panel>
            </nz-collapse>
        </nz-tab>
    </nz-tabs>
</div>

<div class="extra-new">
    
    <div class="extra-new-detail">
        <span style="color:red" *ngIf="!editKey">{{keyName}}</span>
        <input nz-input placeholder="{{'workflow.key.name'|translateTA}}" 
            *ngIf="editKey"
            [ngModel]="keyName"
            (ngModelChange)="onInputChange($event)"
            class="extra-input"

        />
        <button nz-button *ngIf="!editKey && !isConnection" nzType="text" nzSize="small" (click)="editKey=true">
            <nz-icon nzType="edit" nzTheme="outline" />
        </button>
        <button nz-button *ngIf="editKey && !isConnection" nzType="text" nzSize="small" (click)="changeKey(node,keyName);editKey=false">
            <nz-icon nzType="check" nzTheme="outline" /> 
        </button>
    </div>
</div>